function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Maps",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Home-Landing---map-cluster",
  transform: "translate(-1381.000000, -139.000000)",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-7",
  transform: "translate(1209.000000, 139.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "cloud-outlined",
  transform: "translate(172.000000, 0.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M19.0761555,9.80470588 C17.9936975,6.96235294 15.2355567,4.94117647 12.0047269,4.94117647 C8.77389706,4.94117647 6.0157563,6.96 4.93329832,9.80235294 C2.90782563,10.3317647 1.41176471,12.1670588 1.41176471,14.3529412 C1.41176471,16.9529412 3.52704832,19.0588235 6.13629202,19.0588235 L17.863708,19.0588235 C20.4729517,19.0588235 22.5882353,16.9529412 22.5882353,14.3529412 C22.5882353,12.1717647 21.0969013,10.3364706 19.0761555,9.80470588 Z M19.9340861,16.4164706 C19.386255,16.9650561 18.640724,17.2726188 17.863708,17.2705982 L6.13629202,17.2705982 C5.3539916,17.2705982 4.61896008,16.9670588 4.06591387,16.4164706 C3.51480929,15.8701576 3.20591791,15.1271996 3.2079729,14.3529412 C3.2079729,13.6941176 3.42305672,13.0752941 3.82720588,12.5576471 C4.22298172,12.0561863 4.77096537,11.6955137 5.38944328,11.5294118 L6.28518908,11.2964706 L6.61370798,10.4352941 C6.81696429,9.89882353 7.10057773,9.39764706 7.45745798,8.94352941 C7.80978088,8.4934299 8.22712436,8.09776421 8.69590336,7.76941176 C9.66727941,7.08941176 10.811187,6.72941176 12.0047269,6.72941176 C13.1982668,6.72941176 14.3421744,7.08941176 15.3135504,7.76941176 C15.7838761,8.09882353 16.1998424,8.49411765 16.5519958,8.94352941 C16.9088761,9.39764706 17.1924895,9.90117647 17.3957458,10.4352941 L17.7219013,11.2941176 L18.6152836,11.5294118 C19.8986345,11.8705882 20.7920168,13.0305882 20.7920168,14.3529412 C20.7920168,15.1317647 20.4871324,15.8658824 19.9340861,16.4164706 L19.9340861,16.4164706 Z",
  id: "Shape",
  fill: "#8C8C8C"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fillOpacity: 0,
  fill: "#000000",
  x: 0,
  y: 0,
  width: 24,
  height: 24
})))));

var SvgOffline = function SvgOffline(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgOffline, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/offline.02e3a531.svg";
export { ForwardRef as ReactComponent };